import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/templates/Main'
import Category from '@/templates/Category'
import Article from '@/templates/Article'
import Results from '@/templates/Results'
import Form from '@/templates/Form'

const SITE_NAME = {
  johnjohndenim : "John John",
  bobo: "Bo.Bô",
  lelis: "Le Lis Blanc", 
  dudalina: "Dudalina",
  rosacha: "Rosa Chá",
  estoque: "Estoque"
}
let siteTitle = SITE_NAME[window.location.hostname.split('.')[1] || "bobo"];

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Main",
    component: Main,
    meta: {
      title: `Central de Ajuda | ${siteTitle}`,
    }
  },
  {
    path: `/category/:categoryId/`,
    name: 'Category',
    component: Category,
    meta: {
      title: `Categorias | ${siteTitle}`,
    }
  },
  {
    path: `/category/:categoryId/article/:articleId/`,
    name: 'Article',
    component: Article,
    meta: {
      title: `Artigos | ${siteTitle}`,
    }
  },
  {
    path: `/busca`,
    name: 'Resultados',
    component: Results,
    meta: {
      title: `Resultados | ${siteTitle}`,
    }
  },
  {
    path: `/new-request/`,
    name: "Form",
    component: Form,
    meta: {
      title: `Formulário | ${siteTitle}`,
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes
});


router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  next();
});
export default router;
